var Art_meines_Geschäfts_text, anderesCheckBox, form, validateForm;

validateForm = function(data) {
  var isValid;
  isValid = true;
  if (!data["Ich_interessiere_mich_für"]) {
    isValid = false;
    document.getElementById("Ich_interessiere_mich_für_error").classList.remove('d-none');
  }
  if (!data["Art_meines_Geschäfts"]) {
    isValid = false;
    document.getElementById("Art_meines_Geschäfts_error").classList.remove('d-none');
  }
  return isValid;
};

form = document.getElementById("contact-form");

form.addEventListener('submit', function(event) {
  var formData, formObject;
  event.preventDefault();
  document.getElementById("Ich_interessiere_mich_für_error").classList.add('d-none');
  document.getElementById("Art_meines_Geschäfts_error").classList.add('d-none');
  formData = new FormData(form);
  formObject = {};
  formData.forEach(function(val, key) {
    var current;
    if (formObject[key]) {
      if (Array.isArray(formObject[key])) {
        return formObject[key].push(val);
      } else {
        current = formObject[key];
        return formObject[key] = [current, val];
      }
    } else {
      return formObject[key] = val;
    }
  });
  if (validateForm(formObject)) {
    document.getElementById('contact-submit-btn').classList.add('opacity-75');
    document.getElementById('contact-submit-btn').disabled = true;
    return fetch('core/contact-b2b.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formObject)
    }).then(function() {
      document.getElementById('success-message').classList.remove('d-none');
      return form.classList.add('d-none');
    }).catch(function(error) {
      console.error(error);
      return alert("Something went wrong");
    });
  }
});

anderesCheckBox = document.getElementById("Anderes");

Art_meines_Geschäfts_text = document.getElementById("Art_meines_Geschäfts_text");

document.getElementById("Anderes").addEventListener('change', function() {
  if (anderesCheckBox.checked) {
    Art_meines_Geschäfts_text.disabled = false;
    return Art_meines_Geschäfts_text.required = true;
  } else {
    Art_meines_Geschäfts_text.disabled = true;
    Art_meines_Geschäfts_text.required = false;
    return Art_meines_Geschäfts_text.value = '';
  }
});

window.onload = function() {
  var currentUrl, queryParams, shouldOpenModal, url;
  queryParams = new URLSearchParams(window.location.search);
  shouldOpenModal = queryParams.get('with_b2b_modal');
  if (shouldOpenModal) {
    document.getElementById('btn-open-contact-modal-1').click();
    currentUrl = window.location.href;
    url = new URL(currentUrl);
    url.searchParams.delete('with_b2b_modal');
    return window.history.replaceState({}, document.title, url.toString());
  }
};
